// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"5022": "6a40370277d8","6578": "96d1786b0b93","6863": "454c9f289029","8357": "dd422574e14d","8481": "0d9b0ffb81b2","8990": "7d69c8cdd354",}[chunkId] + ".css"
}